import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { SuccessRegTemplate } from '../../components/Templates/Auth/SuccessRegTemplate';
import {
  getWebPageLink,
  WebPageLink,
  WebPageType,
} from '../../constants/webPageType';
import { useShareData } from '../../context';

interface SuccessRegScreenProps {
  webPageType: WebPageType;
}

const SuccessRegScreen: React.FC<SuccessRegScreenProps> = ({ webPageType }) => {
  const navigate = useNavigate();
  const { sharedData, setSharedData } = useShareData();
  // const isLoggedIn = useSessionStore((state) => state.isLoggedIn);

  const onClickContinue = useCallback(() => {
    if (sharedData) {
      const pageUrl = window.location.href;

      const updatedUrl = new URL(pageUrl);
      if (sharedData.pathName) {
        updatedUrl.pathname = sharedData.pathName;
      }

      const queryParams = new URLSearchParams();
      if (sharedData.searchReferralCode) {
        queryParams.set('referralCode', sharedData.searchReferralCode);
      }
      updatedUrl.search = queryParams.toString();

      const newUrl =
        updatedUrl.pathname + (updatedUrl.search ? `${updatedUrl.search}` : '');

      const finalUrl = decodeURIComponent(newUrl.toString());

      navigate(finalUrl, { replace: true });
    } else {
      navigate(getWebPageLink(webPageType, WebPageLink.Home));
    }
    setSharedData(undefined);
  }, [navigate, setSharedData, sharedData, webPageType]);

  return (
    <SuccessRegTemplate
      webPageType={webPageType}
      onClickContinue={onClickContinue}
    />
  );
};
export default SuccessRegScreen;
